import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {ImageViewer} from "../components/detail/ImageViewer";
import {Heading3} from "../components/detail/Heading3";
import {Paragraph} from "../components/detail/Paragraph";
import {UserBadge} from "../components/common/UserBadge";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import {PrimaryButton} from "../components/buttons/PrimaryButton";
import {DateRange} from "react-day-picker";
import {DateRangePickerComponent} from "../components/form/DateRangePickerComponent";
import {Timeline} from "../components/detail/Timeline"
import InfoIcon from '@mui/icons-material/Info';
import {useAppSelector} from "../store/hooks"
import {ProductListResponse, ProductPublicDetailResponseStatus} from "../api/requests/interfaces/Product";
import {SpinnerContainer} from "../components/common/SpinnerContainer";
import {getProductDetails} from "../api/requests/product";
import {DisplayType} from "../store/features/displaySlice";
import {Tooltip} from "@mui/material";
import {InlineInfoBox} from "../components/common/InlineInfoBox";
import EditIcon from '@mui/icons-material/Edit';
import api from "../api/apiInstance";
import {isSameDay} from "date-fns";
import {FavoriteButton} from "../components/listing/FavoriteButton";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import TimeSelector from "../components/form/TimeSelector";
import {ChatRequestViewProps} from "../components/chat/ChatRequestView";
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import {Helmet} from "react-helmet-async";
import ReactGA from 'react-ga4';
import {ProductCategory} from "../constants/products";
import {ApiError} from "../api/apiError";
import AvailabilityCalendar from "../components/detail/AvailabilityCalendar";

export const ItemDetailPage: React.FC = () => {
    let { productId } = useParams();
    const [productData, setProductData] = useState<ProductListResponse | undefined>()
    const [loadingData, setLoadingData] = useState(false);
    const user = useAppSelector(state => state.auth.user);

    const [startTime, setStartTime] = useState<string | undefined>(undefined);
    const [endTime, setEndTime] = useState<string | undefined>(undefined);
    const [productDetailErrorResponseStatus, setProductDetailErrorResponseStatus] =
        useState<ProductPublicDetailResponseStatus | undefined>(undefined);
    const [detailedTimelineModalOpen, setDetailedTimelineModalOpen] = useState(false);

    const [invalidFields, setInvalidFields] = useState({
        startDate: false,
        endDate: false,
        startTime: false,
        endTime: false
    });

    const navigate = useNavigate();

    const testImages = [
        "https://www.protoolreviews.com/wp-content/smush-webp/2020/06/Makita-18V-Planer05.jpg.webp",
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqF9Sx59vA1zH4lEWJCxZ4YQbGkr9GlDzkkQ&s",
        "https://media.screwfix.com/is/image/ae235/makita_main_cat_block_powertools?dpr=on,2&wid=382&hei=288",
        "https://www.hvpmag.co.uk/Images/teaser//W140/makita_wrench_75L.png",
        "https://i0.wp.com/toolguyd.com/blog/wp-content/uploads/2024/08/Makita-XGT-Cordless-Oscillating-Multi-Tool.jpg?resize=600%2C444&ssl=1",
        "https://images.thdstatic.com/productImages/5a2c8170-9ba1-4df9-b095-3caa79b7700e/svn/makita-power-cutting-tools-xcm01z-64_600.jpg",
        "https://hub.its.co.uk/wp-content/uploads/2024/05/BO001CG-40V-XGT-125mm-Brushless-Random-Orbit-Sander.jpg.webp"
    ]

    const [rentDateRange, setRentDateRange] = useState<DateRange | undefined>({ from: undefined, to: undefined })
    const [validDates, setValidDates] = useState(true);
    const [validTimes, setValidTimes] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        if (productId) {
            fetchProductDetail();
        }

    }, [productId])

    const fetchProductDetail = async () => {
        setLoadingData(true);
        try {
            const res = await getProductDetails(Number(productId));
            setProductData(res);
        } catch (e) {
            if (e instanceof ApiError) {
                if (e.code != undefined) {
                    setProductDetailErrorResponseStatus(e.code as ProductPublicDetailResponseStatus)
                }
            } else {
                console.error("Unknown error:", e);
            }
        }
        setLoadingData(false);
    }

    const submitDates = () => {
        const da = rentDateRange?.from;
        // da?.setHours(2)
        console.log('dates ', da);

        api.post(process.env.REACT_APP_RENTIC_API_URL! + '/rentals/test', { startDate: rentDateRange?.from })
    }

    const handleRentThis = () => {

        let invalid = false;

        if (!rentDateRange) {
            return;
        }

        if (!rentDateRange?.from) {
            setInvalidFields((prevState) => ({ ...prevState, startDate: true }));
            invalid = true;
        } else {
            setInvalidFields((prevState) => ({ ...prevState, startDate: false }));
        }

        if (!rentDateRange?.to) {
            setInvalidFields((prevState) => ({ ...prevState, endDate: true }));
            invalid = true;
        } else {
            setInvalidFields((prevState) => ({ ...prevState, endDate: false }));
        }

        if (!startTime) {
            setInvalidFields((prevState) => ({ ...prevState, startTime: true }));
            invalid = true;
        } else {
            setInvalidFields((prevState) => ({ ...prevState, startTime: false }));
        }

        if (!endTime) {
            setInvalidFields((prevState) => ({ ...prevState, endTime: true }));
            invalid = true;
        } else {
            setInvalidFields((prevState) => ({ ...prevState, endTime: false }));
        }

        if (invalid || !validDates || !validTimes) {
            return;
        }


        // set time values of dates
        rentDateRange.from!.setHours(Number(startTime!.split(":")[0]))
        rentDateRange.from!.setMinutes(Number(startTime!.split(":")[1]))
        rentDateRange.to!.setHours(Number(endTime!.split(":")[0]))
        rentDateRange.to!.setMinutes(Number(endTime!.split(":")[1]))

        ReactGA.event({
            category: 'ItemDetailPage',
            action: 'Rendi seda nupp (väljade kontrolliga)'
        });

        navigate('/rentals-chats?new=true',
            {
                state: {
                    productData: productData,
                    startDate: rentDateRange.from,
                    endDate: rentDateRange.to,
                    startTime: startTime,
                    endTime: endTime,
                } as ChatRequestViewProps

            });
    }

    const handleTimeChange = (type: 'start' | 'end', value: string | undefined) => {
        let startTimeVal = startTime;
        let endTimeVal = endTime;

        if (type === "start") {
            startTimeVal = value;
        } else {
            endTimeVal = value;
        }

        setInvalidFields((prevState) => ({ ...prevState, startTime: false, endTime: false }));
        handleTimeFieldsCheck(startTimeVal, endTimeVal);
    }

    const handleTimeFieldsCheck = (startTimeVal: string | undefined, endTimeVal: string | undefined) => {
        setStartTime(startTimeVal);
        setEndTime(endTimeVal);

        if (rentDateRange?.from && rentDateRange.to && validDates && startTimeVal && endTimeVal) {
            let startHour = Number(startTimeVal.split(":")[0]);
            let startMin = Number(startTimeVal.split(":")[1]);
            let endHour = Number(endTimeVal.split(":")[0]);
            let endMin = Number(endTimeVal.split(":")[1]);
            if (isSameDay(rentDateRange.to, rentDateRange.from) && (startHour == endHour ? startMin > endMin : startHour > endHour)) {
                setValidTimes(false);
            } else {
                setValidTimes(true);
            }
        }
    }

    const convertCategoryToLabel = (category: ProductCategory) => {
        switch (category) {
            case ProductCategory.DEVICES:
                return 'seadmed'
            case ProductCategory.TOOLS:
                return 'tööriistad'
            case ProductCategory.TRANSPORTATION:
                return 'sõidukid ja haagised'
            case ProductCategory.REALESTATE:
                return 'kinnisvara'
            case ProductCategory.SERVICES:
                return 'teenused'
        }
    }

    const getProductDetailLoadFailText = (errorStatus: ProductPublicDetailResponseStatus): string => {
        switch (errorStatus) {
            case ProductPublicDetailResponseStatus.EXPIRED:
                return "Kuulutus on aegunud"
            default:
                return "Toode puudub"
        }
    }

    return (
        <div className="flex flex-col gap-16 mb-2 mt-20">

            <Helmet>
                <title>{productData ? `${productData.title} - Rentic` : "Loading..."}</title>
                <meta name="description" content={productData ? productData.description : "Loading product details..."} />
                <meta property="og:title" content={productData ? `${productData.title} - Rentic` : "Loading..."} />
                <meta property="og:description" content={productData ? productData.description : "Find amazing rental products."} />
                <meta property="og:image" content={productData?.pictures[0]?.publicUrl || "/logo512.png"} />
                <meta property="og:url" content={`https://rentic.ee/detail/${productId}`} />
            </Helmet>

            {
                detailedTimelineModalOpen && productData &&
                <div className="fixed left-0 top-0 w-full h-full bg-gray-500/50 z-50 flex justify-center"
                     onClick={() => setDetailedTimelineModalOpen(false)}>
                    <div onClick={(e) => e.stopPropagation()}
                         className="w-fit mt-10 p-1 h-fit">
                        <AvailabilityCalendar availability={productData.availableDates} closeModal={() =>
                            setDetailedTimelineModalOpen(false)}/>
                    </div>
                </div>
            }

            <div className="w-full">
                {
                    productDetailErrorResponseStatus != undefined &&
                    <InlineInfoBox type={"alert"} text={getProductDetailLoadFailText(productDetailErrorResponseStatus)} />
                }
                <SpinnerContainer show={loadingData} fullWidth={true}>
                    {
                        productData &&
                        <div className="flex flex-col lg:flex-row rounded-xl shadow-main p-2 pt-4 gap-8 lg:gap-12 w-full">
                            <div className="w-full lg:w-[60%]">
                                <ImageViewer imageUrls={productData?.pictures.map((itm) => itm.publicUrl)} />
                            </div>
                            <div className="flex flex-col w-full lg:w-[40%] items-start">
                                <div className="flex flex-row w-full justify-between">
                                    <h1 className="text-2xl lg:text-4xl font-bold text-left">{productData?.title}</h1>
                                    {user?.id === productData?.userId ?
                                        <div className="w-[110px]">
                                            <PrimaryButton title={"Muuda"} icon={<EditIcon />} onClick={() => { navigate("/edit?type=edit&id=" + productData?.id) }} />
                                        </div> :
                                        <div className="p-2">
                                            <FavoriteButton initialValue={false /* TODO: check if is user favorite */} productId={productData?.id} />
                                        </div>
                                    }


                                </div>
                                <div className="font-light underline">{productData && convertCategoryToLabel(productData?.category)}</div>
                                {productData ?
                                    <div className="flex flex-row items-center mt-4">
                                        <UserBadge profileIconUrl={productData?.userProfile.picUrl!} profileId={productData?.userProfile.id!} />
                                        <div className="font-bold text-lg pl-2 hover:underline cursor-pointer" onClick={() => navigate('/profile/' + productData.userProfile.id.toString())}>
                                            {productData?.userProfile.name}</div>
                                        {
                                            productData.userProfile.verified &&
                                            <div className="pl-1">
                                                <Tooltip title={"Verifitseeritud kasutaja. Kasutaja juriidiline nimi"} arrow>
                                                    <VerifiedUserOutlinedIcon style={{ width: "20px", height: "20px" }} className="text-primary" />
                                                </Tooltip>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <div className="flex flex-row items-center mt-4">
                                        <div className="w-[64px] h-[64px] skeleton_shine rounded-full"></div>
                                        <div className="w-[100px] h-[18px] skeleton_shine rounded-lg"></div>
                                    </div>
                                }
                                <div className="mt-10 text-start">
                                    <div className="flex flex-row gap-2 items-center pb-3">
                                        <h3>Saadavus</h3>
                                        <Tooltip title={DisplayType.DESKTOP ? "Mine hiirega päeva peale, et näha täpsemat infot" : "Vajuta ja hoia ühte päeva, et näha täpsemat infot."} arrow>
                                            <InfoIcon className="cursor-pointer text-blue-500" style={{ width: '18px', height: '18px' }} />
                                        </Tooltip>
                                    </div>

                                    {productData?.availableDates &&
                                        <Timeline availableDates={productData.availableDates} />
                                    }
                                    <div className="text-primary underline cursor-pointer" onClick={() =>
                                    setDetailedTimelineModalOpen(true)}>Ava kalendrivaade
                                    <OpenInNewOutlinedIcon style={{width: "18px", height: "18px"}} className="ml-1"/></div>
                                    <div className="h-10"></div>
                                    <span className="font-light">Alates</span>
                                    <h1 className="font-bold text-3xl xl:text-5xl">€{productData?.dailyPrice} <span className="text-xl">/päev</span></h1>
                                    <div className="pt-1 flex flex-row items-center">
                                        <FmdGoodOutlinedIcon style={{ width: '30px', height: '30px' }} className="text-primary" />
                                        {
                                            productData?.location &&
                                            <div>{productData!.location.charAt(0).toUpperCase() + productData!.location.slice(1)}</div>
                                        }
                                    </div>
                                </div>
                                {((user?.id !== productData?.userId) && productData) ?
                                    <div className="w-full lg:w-[70%] mt-[20px] lg:mt-[20px] relative">
                                        {
                                            (!validDates && rentDateRange?.from && rentDateRange.to) &&
                                            <InlineInfoBox type={"error"} text={"Lõppkuupäev ei saa olla enne alguskuupäeva"} />
                                        }
                                        <div className="flex flex-row items-center gap-4">
                                            <div className="text-primary mb-4">
                                                <CalendarMonthOutlinedIcon />
                                            </div>

                                            <DateRangePickerComponent dateValues={rentDateRange} dateRangeChanged={(d) => { handleTimeFieldsCheck(startTime, endTime); setRentDateRange(d) }} validChanged={(v) => setValidDates(v)}
                                                                      invalid={invalidFields.startDate || invalidFields.endDate} />
                                        </div>
                                        <div className="flex flex-row items-center gap-4">
                                            <div className="text-primary mb-4">
                                                <AccessTimeOutlinedIcon />
                                            </div>
                                            <div className="flex flex-row gap-x-2 mb-4">
                                                <TimeSelector value={startTime} onTimeChange={(v) => { handleTimeChange("start", v) }} invalid={!validTimes || invalidFields.startTime} />
                                                <TimeSelector value={endTime} onTimeChange={(v) => { handleTimeChange("end", v) }} invalid={!validTimes || invalidFields.endTime} />
                                            </div>
                                        </div>

                                        <PrimaryButton title="Rendi seda" textSize="l" onClick={() => handleRentThis()} />
                                    </div>
                                    : <></>}
                            </div>
                        </div>
                    }
                </SpinnerContainer>
            </div>
            {
                productData &&
                <div className="flex flex-col gap-12 w-full mx-auto">
                    <div className="flex flex-col text-left gap-0 lg:flex-col max-w-[600px]">
                        <div className="flex flex-col gap-10">
                            <div>
                                <Heading3 title={"Kirjeldus"} />
                                <Paragraph text={productData?.description ? productData?.description : ""} />
                            </div>
                            <div className="flex flex-col p-6 gap-10 bg-[#32a5db15] rounded-xl">
                                <div>
                                    <Heading3 title={"Hinnakiri"} />
                                    <ul className="list-disc list-inside">
                                        <li><span className="product-details-bold">Päev:</span> {productData?.dailyPrice}€</li>
                                        <li><span className="product-details-bold">Tund:</span> {productData?.hourlyPrice ? productData.hourlyPrice + "€" : "pole määratud"}</li>
                                        <li><span className="product-details-bold">Nädal:</span> {productData?.weeklyPrice ? productData.weeklyPrice + "€" : "pole määratud"}</li>
                                        <li><span className="product-details-bold">Kuu:</span> {productData?.monthlyPrice ? productData.monthlyPrice + "€" : "pole määratud"}</li>
                                    </ul>
                                </div>
                                {/* <div>
                                <Heading3 title={"Kasulik info"} />
                                <ul className="list-disc list-inside">
                                    <li><span className="product-details-bold">Ostu Tühistamise Reeglid:</span> Flexible</li>
                                    <li><span className="product-details-bold">Kindlustus:</span> External Insurance Available</li>
                                    <li><span className="product-details-bold">Lühim Rentimisaeg:</span> 3 päeva</li>
                                    <li><span className="product-details-bold">Pikim Rentimisaeg:</span> Piiramatu</li>
                                </ul>
                            </div> */}
                                {/* <div>
                                <Heading3 title={"Omanik on juba vastanud küsimustele"} />
                                <Accordion className="bg-primary" slotProps={{ heading: { component: 'h4' } }}>
                                    <AccordionSummary
                                        expandIcon={"▼"}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <span className="product-accordion-bold">Palju peab maksma selle eest?</span>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada
                                        lacus ex, sit amet blandit leo lobortis eget.
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion className="bg-primary" slotProps={{ heading: { component: 'h4' } }}>
                                    <AccordionSummary
                                        expandIcon={"▼"}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <span className="product-accordion-bold">Mis seisus see on?</span>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada
                                        lacus ex, sit amet blandit leo lobortis eget.
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion className="bg-primary" slotProps={{ heading: { component: 'h4' } }}>
                                    <AccordionSummary
                                        expandIcon={"▼"}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <span className="product-accordion-bold">Palju peab maksma selle eest?</span>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada
                                        lacus ex, sit amet blandit leo lobortis eget.
                                    </AccordionDetails>
                                </Accordion>
                            </div> */}
                            </div>

                        </div>
                        <div className="flex flex-col gap-6">
                            <div>
                                {/* <Heading3 title={"Müüja asukoht"} />
                            <LocationMap coordinates={""} /> */}
                                <div className="flex flex-col justify-start bg-primary p-10 mt-10 rounded-xl min-h-[200px]">

                                    <h1 className="text-white text-4xl font-bold mb-10">
                                        Meeldib see ese?
                                    </h1>
                                    <div className="w-[160px]">
                                        <PrimaryButton title="Rendi seda" textSize="l" onClick={() => {
                                            window.scrollTo({
                                                top: 0,
                                                left: 0,
                                                behavior: 'smooth'
                                            });
                                        }} />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    {/* <div className="align-left">
                    <Heading3 title={"Sarnased esemed"} />
                    <div className="flex flex-row gap-6">
                        <div>
                            <div className="flex flex-row">
                                <img src="" alt="" />
                                Kasutajanimi
                            </div>
                            <img className="rounded-xl" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqF9Sx59vA1zH4lEWJCxZ4YQbGkr9GlDzkkQ&s" alt="" />
                            <div className="flex flex-col mt-3">
                                <div className="text-xl font-semibold">Sony Lens</div>
                                <div className="text-[13px]">15€/päevas</div>

                            </div>
                        </div>
                        <div>
                            <div className="flex flex-row">
                                <img src="" alt="" />
                                Kasutajanimi
                            </div>
                            <img className="rounded-xl" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqF9Sx59vA1zH4lEWJCxZ4YQbGkr9GlDzkkQ&s" alt="" />
                            <div className="flex flex-col mt-3">
                                <div className="text-xl font-semibold">Sony Lens</div>
                                <div className="text-[13px]">15€/päevas</div>

                            </div>
                        </div>
                        <div>
                            <div className="flex flex-row">
                                <img src="" alt="" />
                                Kasutajanimi
                            </div>
                            <img className="rounded-xl" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqF9Sx59vA1zH4lEWJCxZ4YQbGkr9GlDzkkQ&s" alt="" />
                            <div className="flex flex-col mt-3">
                                <div className="text-xl font-semibold">Sony Lens</div>
                                <div className="text-[13px]">15€/päevas</div>

                            </div>
                        </div>
                    </div>


                </div> */}
                </div>
            }
        </div>
    )

}